import React, { useEffect, useState } from "react";
import { session_id_beg, session_id_end } from "../../../../../utils/helpers";

export default function NoshowBox({
  noShowActive,
  list = [],
  noShowRequest,
  noshowRemoveGroupAppointment,
  noshowFrom
}) {
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    console.log(list, "list");
  }, [list]);

  const filteredList = list.filter(item =>
    item.client &&
    item.client.screen_name &&
    item.client.screen_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="register-medium">
      <div
        className="modal fade"
        id="NoshowBox"
        role="dialog"
      >
        <div className="width-unset modal-dialog advanceConfirmbooking modal-lg modal-dialog-preview height-unset">
          <div className="modal-content p-5">
            <div className="modal-body">
              <div className="schedule-popup">
                <h3 className="mb-4 mt-2 text-center">
                  Attendees For{" "}
                  {noShowActive !== undefined &&
                    `${session_id_beg}${noShowActive.id}${session_id_end}`}
                </h3>

                {/* 🔍 Search Input */}
                <input
                  type="text"
                  className="mb-4 mt-2 text-center attendees-search-input"
                  placeholder="Search name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />

                <div className="now-show-box-wrapper">
                  {filteredList.length > 0 ? (
                    filteredList.map((item, index) => (
                      <div
                        key={index}
                        className={`profilecard-wrapper justify-content-between pointer w-90`}
                      >
                        <div className="d-flex align-items-center">
                          <div className="profile-photo">
                            <div>
                              <img
                                width="100%"
                                height="100%"
                                src={
                                  item.client.profile_image !== null
                                    ? `${process.env.REACT_APP_IMAGE_URL}${item.client.profile_image}`
                                    : "/images/user-dummy.png"
                                }
                                alt="Profile"
                              />
                            </div>
                          </div>
                          <div className="font-size-15 text-left ml-2">
                            {item.client.screen_name}
                            <br />
                            {item.client.email}
                          </div>
                        </div>
                        <div>
                          {item.status === 0 || item.status === 1 ? (
                            <>
                              {noshowFrom === "remove" && (
                                <div
                                  className="margin-unset register-medium-confirnation appointment-no-show-card"
                                  onClick={() =>
                                    noshowRemoveGroupAppointment(item)
                                  }
                                  data-dismiss="modal"
                                >
                                  Remove
                                </div>
                              )}
                              &nbsp;&nbsp;&nbsp;&nbsp;
                              <div
                                className="margin-unset register-medium-confirnation appointment-no-show-card"
                                onClick={() => noShowRequest(item)}
                                data-dismiss="modal"
                              >
                                No Show
                              </div>
                            </>
                          ) : (
                            <span>
                              <b>
                                {item.status === 2
                                  ? `No Show by ${item.userbyName} at ${item.userbyDate}`
                                  : item.status === 3
                                  ? `Removed by ${item.userbyName} at ${item.userbyDate}`
                                  : ""}
                              </b>
                            </span>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No matching attendees found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
